"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = void 0;

var _primitives = require("../../platform/primitives");

var _styledSystem = require("styled-system");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var flexGrow = (0, _styledSystem.style)({
  prop: "flexGrow"
});

/**
 * A utility component that encapsulates flexbox behavior
 */
var Flex = _primitives.styled.View(_templateObject(), _styledSystem.alignContent, _styledSystem.alignItems, _styledSystem.background, _styledSystem.bottom, _styledSystem.display, _styledSystem.flexBasis, _styledSystem.flexDirection, flexGrow, _styledSystem.flexWrap, _styledSystem.height, _styledSystem.justifyContent, _styledSystem.maxHeight, _styledSystem.maxWidth, _styledSystem.order, _styledSystem.position, _styledSystem.space, _styledSystem.width, _styledSystem.zIndex);

exports.Flex = Flex;
Flex.displayName = "Flex";
//# sourceMappingURL=Flex.js.map